import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCarTaxi: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCarTaxi"><Path fillRule="evenodd" clipRule="evenodd" d="M20.8682 9H23V11H22V20H17V18H7V20H2V11H1V9H3.13184L6.46484 4H9V2H15V4H17.5352L20.8682 9ZM5 14H8V12H5V14ZM16 14H19V12H16V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCarTaxi;
